import { IconCompleteSolid, Text } from "@instructure/ui";
import { t } from "i18next";

const SuccessBody = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: "1.5rem" }}>
        <IconCompleteSolid color="success" size="medium" />
      </div>
      <Text size="medium" as="p" weight="bold" color="primary">
        {t("finalizeCourse.successBody")}
      </Text>
    </div>
  );
};

export default SuccessBody;
